export default {
  packages: (state) => state.packages,
  package: (state) => (id) => state.packages.filter((item) => item.id == id)[0],
  mySubs: (state) => state.mySubs,
  sub: (state) => (id) => state.mySubs.filter((sub) => sub.id == id)[0],
  fibToken: (state) => state.fibToken,
};
